// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","root":"AutocompleteResult_root__-81k7","focused":"AutocompleteResult_focused__McVGd"};